/* Professional enquiry only: no cart, price or product-data mutations. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.proReady) return;
    root.dataset.proReady = 'true';
    const form = root.querySelector('form');
    if (!form) return;
    const fields = [...root.querySelectorAll('[data-selection-label]')];
    const storageKey = 'rd-pro-v1:' + root.dataset.draftKey;
    const choice = root.querySelector('[data-fabric-choice]');
    const reference = root.querySelector('[data-fabric-reference]');
    const customChoices = [...root.querySelectorAll('[data-custom-choice]')];
    const quantity = root.querySelector('[data-pro-quantity]');
    const sideboardLength = root.querySelector('[data-pro-length]');
    const sideboardBase = [...root.querySelectorAll('[data-sideboard-base]')];
    const sideboardMetalOptions = root.querySelector('[data-sideboard-metal-options]');
    const zoomDialog = root.querySelector('[data-zoom-dialog]');
    const zoomLinks = [...root.querySelectorAll('[data-zoom]')].filter((link, index, links) => links.findIndex(candidate => candidate.href === link.href) === index);
    let zoomIndex = 0;
    let activeZoomLink;
    function renderZoom() {
      if (!zoomDialog || !zoomLinks.length) return;
      const link = zoomLinks[zoomIndex];
      const image = zoomDialog.querySelector('img');
      image.src = link.href;
      image.alt = link.querySelector('img')?.alt || '';
      zoomDialog.querySelector('[data-zoom-counter]').textContent = zoomLinks.length > 1 ? `${zoomIndex + 1} / ${zoomLinks.length}` : '';
      zoomDialog.querySelectorAll('[data-zoom-prev], [data-zoom-next]').forEach(button => { button.hidden = zoomLinks.length < 2; });
    }
    function moveZoom(step) {
      if (zoomLinks.length < 2) return;
      zoomIndex = (zoomIndex + step + zoomLinks.length) % zoomLinks.length;
      renderZoom();
    }
    const succeeded = !!root.querySelector('[data-inquiry-success]');
    const successDialog = root.querySelector('[data-inquiry-dialog]');
    const feedback = root.querySelector('.rd-pro-alert');
    if (feedback) {
      let panel = feedback.closest('details');
      while (panel) { panel.open = true; panel = panel.parentElement.closest('details'); }
    }
    if (succeeded) {
      try { sessionStorage.removeItem(storageKey); } catch (_) { /* Storage is optional. */ }
    } else {
      try {
        const draft = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
        if (draft['contact[Custom requirements]'] && !draft['contact[body]']) draft['contact[body]'] = draft['contact[Custom requirements]'];
        fields.forEach(field => {
          if (typeof draft[field.name] !== 'string') return;
          if (field.type === 'radio') field.checked = field.value === draft[field.name];
          else field.value = draft[field.name];
        });
        // Preserve the frame choice in enquiries saved before the base selector existed.
        if (sideboardBase.length && !draft[sideboardBase[0].name] && draft['contact[Metal frame colour]']) {
          sideboardBase.forEach(field => { field.checked = field.value === 'Metal frame'; });
        }
        customChoices.forEach(field => {
          const stored = draft[field.name];
          if (stored && ![...field.options].some(option => option.value === stored)) {
            field.value = 'Custom';
            const custom = root.querySelector('[data-custom-reference="' + field.dataset.customChoice + '"] input');
            if (custom) custom.value = stored;
          }
        });
      } catch (_) { /* Malformed or unavailable storage must not block enquiries. */ }
    }
    function refresh() {
      const wallpaperType = root.querySelector('[data-wallpaper-type]');
      const wallpaperSurface = root.querySelector('[data-wallpaper-surface]');
      const canvasNote = root.querySelector('[data-wallpaper-canvas-note]');
      if (canvasNote && wallpaperType) canvasNote.hidden = wallpaperType.value !== 'Peel and stick';
      if (wallpaperType && wallpaperSurface) {
        const traditional = wallpaperType.value === 'Traditional';
        wallpaperSurface.hidden = !traditional;
        wallpaperSurface.querySelector('select').disabled = !traditional;
      }
      if (sideboardMetalOptions) {
        const show = sideboardBase.some(field => field.checked && field.value === 'Metal frame');
        sideboardMetalOptions.hidden = !show;
        sideboardMetalOptions.querySelectorAll('input, select, textarea').forEach(field => { field.disabled = !show; });
      }
      customChoices.forEach(field => {
        const container = root.querySelector('[data-custom-reference="' + field.dataset.customChoice + '"]');
        if (!container) return;
        const show = !field.disabled && field.value === 'Custom';
        container.hidden = !show;
        container.querySelectorAll('input, textarea').forEach(input => { input.disabled = !show; });
      });
      if (choice && reference) {
        const show = choice.value === 'Mercis reference';
        reference.hidden = !show;
        reference.querySelector('input').disabled = !show;
      }
      if (quantity) {
        const raw = quantity.value.trim();
        const number = Number(raw.replace(',', '.'));
        const valid = !raw || (number > 0 && (quantity.dataset.proQuantity === 'wallpaper' || Number.isInteger(number)));
        quantity.setCustomValidity(valid ? '' : quantity.dataset.quantityError);
      }
      if (sideboardLength) {
        const raw = sideboardLength.value.trim();
        const number = Number(raw.replace(',', '.'));
        const maximum = Number(sideboardLength.dataset.proLengthMax);
        const valid = !raw || (Number.isFinite(number) && number > 0 && number <= maximum);
        sideboardLength.setCustomValidity(sideboardLength.disabled || valid ? '' : sideboardLength.dataset.lengthError);
      }
      const lines = fields.filter(field => !field.disabled && (field.type !== 'radio' || field.checked) && field.value.trim()).map(field => {
        const value = field.tagName === 'SELECT' ? field.selectedOptions[0].textContent : (field.dataset.selectionValue || field.value);
        return field.dataset.selectionLabel + ': ' + value.trim();
      });
      root.querySelectorAll('[data-selection-summary]').forEach(summary => {
        summary.textContent = lines.join('; ') || root.dataset.emptySelection;
      });
    }
    function save() {
      refresh();
      const draft = {};
      fields.forEach(field => { if (field.type !== 'radio' || field.checked) draft[field.name] = field.value; });
      try { sessionStorage.setItem(storageKey, JSON.stringify(draft)); } catch (_) { /* No storage fallback needed. */ }
    }
    root.addEventListener('input', save);
    root.addEventListener('change', save);
    root.addEventListener('click', event => {
      const option = event.target.closest('[data-request-option]');
      if (option) {
        const checkbox = root.querySelector('[data-request-' + option.dataset.requestOption + ']');
        if (checkbox) checkbox.checked = true;
      }
      const zoom = event.target.closest('[data-zoom]');
      if (zoom && zoomDialog && typeof zoomDialog.showModal === 'function') {
        event.preventDefault();
        activeZoomLink = zoom;
        zoomIndex = zoomLinks.findIndex(link => link.href === zoom.href);
        if (zoomIndex < 0) zoomIndex = 0;
        renderZoom();
        zoomDialog.showModal();
      }
      if (event.target.closest('[data-zoom-prev]')) moveZoom(-1);
      if (event.target.closest('[data-zoom-next]')) moveZoom(1);
      if (event.target.closest('[data-close-zoom]') && zoomDialog) zoomDialog.close();
    });
    if (zoomDialog) {
      let touchStart;
      zoomDialog.addEventListener('click', event => { if (event.target === zoomDialog) zoomDialog.close(); });
      zoomDialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          moveZoom(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      zoomDialog.addEventListener('touchstart', event => {
        if (event.touches.length === 1) touchStart = [event.touches[0].clientX, event.touches[0].clientY];
      }, {passive:true});
      zoomDialog.addEventListener('touchend', event => {
        if (!touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - touchStart[0];
        const dy = event.changedTouches[0].clientY - touchStart[1];
        touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) moveZoom(dx < 0 ? 1 : -1);
      }, {passive:true});
      zoomDialog.addEventListener('close', () => { if (activeZoomLink) activeZoomLink.focus({preventScroll:true}); });
    }
    // Native validation must reach controls inside collapsed optional panels.
    root.addEventListener('invalid', event => {
      let panel = event.target.closest('details');
      while (panel) { panel.open = true; panel = panel.parentElement.closest('details'); }
    }, true);
    form.addEventListener('submit', refresh);
    refresh();
    let successCloseTimer;
    let successTimerPaused = false;
    function stopSuccessTimer() {
      if (successCloseTimer) window.clearTimeout(successCloseTimer);
      successCloseTimer = null;
    }
    function startSuccessTimer() {
      stopSuccessTimer();
      if (!successDialog || !successDialog.open || successTimerPaused || document.hidden) return;
      successCloseTimer = window.setTimeout(() => {
        if (successDialog.open) successDialog.close();
      }, 10000);
    }
    if (successDialog) {
      successDialog.addEventListener('click', event => {
        if (event.target === successDialog || event.target.closest('[data-close-inquiry-dialog]')) {
          successDialog.close();
        }
      });
      successDialog.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse') return;
        successTimerPaused = true;
        stopSuccessTimer();
      });
      successDialog.addEventListener('pointerleave', () => {
        successTimerPaused = false;
        startSuccessTimer();
      });
      successDialog.addEventListener('keydown', () => {
        successTimerPaused = true;
        stopSuccessTimer();
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopSuccessTimer();
        else startSuccessTimer();
      });
      successDialog.addEventListener('close', () => {
        stopSuccessTimer();
        const submit = form.querySelector('[type="submit"]');
        if (submit) submit.focus({preventScroll: true});
      });
    }
    if (succeeded) {
      const notice = root.querySelector('[data-inquiry-success]');
      if (successDialog && typeof successDialog.showModal === 'function') {
        try {
          successDialog.showModal();
          startSuccessTimer();
        }
        catch (_) { notice.scrollIntoView({block: 'center'}); }
      } else {
        notice.scrollIntoView({block: 'center'});
      }
    }
  }
  function revealHash() {
    if (!location.hash) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (_) { return; }
    if (!target || !target.closest('.rd-pro-overview')) return;
    if (target.tagName === 'DETAILS') target.open = true;
    if (target.matches('#rd-pro-request, #rd-pro-contact')) {
      const input = target.querySelector('input[autocomplete="name"]');
      if (input) input.focus({preventScroll:true});
    }
  }
  document.querySelectorAll('[data-pro-inquiry]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pro-inquiry]').forEach(init));
  document.addEventListener('click', event => {
    const link = event.target.closest('.rd-pro-overview a');
    if (!link) return;
    if (link.dataset.interest) {
      const field = document.querySelector('#rd-pro-contact textarea[name="contact[body]"]');
      if (field && !field.value.trim()) field.value = link.dataset.interest;
    }
    if (link.hash && link.origin === location.origin && link.pathname === location.pathname) {
      const target = document.getElementById(link.hash.slice(1));
      if (target && target.tagName === 'DETAILS') target.open = true;
      if (target && target.matches('#rd-pro-request, #rd-pro-contact')) {
        const input = target.querySelector('input[autocomplete="name"]');
        if (input) input.focus({preventScroll:true});
      }
    }
  });
  window.addEventListener('hashchange', revealHash);
  revealHash();
})();

